import Modal, { ModalBody, ModalFooter } from "@components/ui/Modal";
import Button from "@components/ui/Button";

export default function RunNowConfirmModal({ show, onClose, onConfirm, clinicName, purpose }) {
  return (
    <Modal show={show} onClose={onClose} title="Run tests now (live)">
      <ModalBody>
        <p className="text-sm">
          This runs <strong>live ElevenLabs simulations</strong> for{" "}
          <strong>{clinicName}</strong> · <strong>{purpose}</strong> — one paid simulation per active
          scenario. The queue worker must be enabled for it to execute.
        </p>
      </ModalBody>
      <ModalFooter className="flex justify-end gap-2">
        <Button color="light" onClick={onClose}>Cancel</Button>
        <Button color="primary" onClick={onConfirm}>Confirm</Button>
      </ModalFooter>
    </Modal>
  );
}
